module.exports = __webpack_public_path__ + "static/19-c3f5d81f978cdb4fb8abf9508ba781d5.jpeg";